"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _moment = _interopRequireDefault(require("@package/moment"));

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Periods() {
  try {
    var setNowDate = function setNowDate() {
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateFrom', (0, _moment["default"])().format('YYYY-MM-DD 00:00:00')));
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateTo', (0, _moment["default"])().format('YYYY-MM-DD 23:59:59')));
    };

    var setWeekDate = function setWeekDate() {
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateFrom', (0, _moment["default"])().subtract(1, 'weeks').format('YYYY-MM-DD 00:00:00')));
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateTo', (0, _moment["default"])().format('YYYY-MM-DD 23:59:59')));
    };

    var setNowMonthDate = function setNowMonthDate() {
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateFrom', (0, _moment["default"])().startOf('month').format('YYYY-MM-DD 00:00:00')));
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateTo', (0, _moment["default"])().format('YYYY-MM-DD 23:59:59')));
    };

    var setMonthDate = function setMonthDate() {
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateFrom', (0, _moment["default"])().subtract(1, 'month').startOf('month').format('YYYY-MM-DD 00:00:00')));
      dispatch((0, _reduxForm.change)('invoices-filter', 'dateTo', (0, _moment["default"])().subtract(1, 'month').endOf('month').format('YYYY-MM-DD 23:59:59')));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link'],
      onClick: setNowDate
    }, "\u0421\u0435\u0433\u043E\u0434\u043D\u044F"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link'],
      onClick: setWeekDate
    }, "\u041D\u0435\u0434\u0435\u043B\u044F"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link'],
      onClick: setNowMonthDate
    }, "\u041C\u0435\u0441\u044F\u0446"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['link'],
      onClick: setMonthDate
    }, "\u041F\u0440\u043E\u0448\u043B\u044B\u0439 \u043C\u0435\u0441\u044F\u0446"));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Periods;
exports["default"] = _default;